define( [ 'jquery', 'utility' ], function( $, util ) {
	'use strict';

	var notificationclose = {

		init : function( el ) {
			var $element = $( el );

			if ( !$element.hasClass( 'js-m-card-close' ) ) {
				$element.addClass( 'js-m-card-close' );

				var element_id = $element.attr( 'id' );
				if ( !element_id ) {
					element_id = util.makeId( 'm-card-close-' );
					$element.attr( 'id', element_id );
				}

				$element.append( '<a href="#' + element_id + '" class="m-card__close" aria-controls="' + element_id + '">' + FRAMEWORK.locale.settings.notificationclose.closeText + '</a>' );

				$element.on( 'click', '.m-card__close', function( e ) {
					e.preventDefault();
					$element.slideUp( 350, function() {
						$element.remove();
					});
				});
			}
		}
	};

	return {
		initInstance : function( el ) {
			notificationclose.init( el );
		}
	};
});
